"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportService = void 0;
const axios_1 = __importDefault(require("axios"));
const utils_1 = require("../../../utils/tsUtils/utils");
var JSONbig = require('json-bigint');
class ReportService {
    constructor(baseUrl) {
        this.baseUrl = baseUrl;
    }
    fetchBusinessSumary(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                let url = `${this.baseUrl}hotel_billing/reports/business/summary`;
                if (payload.from_date && payload.to_date) {
                    url = `${url}?from_date=${payload.from_date}&to_date=${payload.to_date}`;
                }
                const response = yield axios_1.default.get(url, {
                    transformResponse: [
                        (data, headers) => {
                            return data;
                        },
                        ...axios_1.default.defaults.transformResponse
                    ],
                    headers: header
                });
                const responseData = response.data.data.data;
                return responseData;
            }
            catch (error) {
                throw new Error('Failed to fetch reports');
            }
        });
    }
    fetchOutletSummary(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                let url = `${this.baseUrl}hotel_billing/reports/business/outlet/summary?from_date=${payload.from_date}&to_date=${payload.to_date}`;
                // Add outlet_id only if it exists
                if (payload.outlet_id) {
                    url += `&outlet_id=${payload.outlet_id}`;
                }
                const response = yield axios_1.default.get(url, {
                    transformResponse: [
                        (data, headers) => {
                            return data;
                        },
                        ...axios_1.default.defaults.transformResponse
                    ],
                    headers: header
                });
                const responseData = response.data.data.data;
                return responseData;
            }
            catch (error) {
                throw new Error('Failed to fetch reports');
            }
        });
    }
    fetchOutletwiseSummary(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                let url = payload !== undefined && payload !== null
                    ? `${this.baseUrl}hotel_billing/reports/outlet/summary?from_date=${payload.from_date}&to_date=${payload.to_date}`
                    : `${this.baseUrl}hotel_billing/reports/outlet/summary`;
                const response = yield axios_1.default.get(url, {
                    transformResponse: [
                        (data, headers) => {
                            return data;
                        },
                        ...axios_1.default.defaults.transformResponse
                    ],
                    headers: header
                });
                const responseData = response.data.data;
                return responseData;
            }
            catch (error) {
                throw new Error('Failed to fetch reports');
            }
        });
    }
    fetchOutletwiseSummaryForFranchise(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                let url = payload.sub_business_name !== undefined &&
                    payload.sub_business_name !== ''
                    ? `${this.baseUrl}hotel_billing/reports/franchise/outlet/summary?from_date=${payload.from_date}&to_date=${payload.to_date}&by_business_name=${payload.by_business_name}&page=${payload.pageNumber}&limit=${payload.limit}&sub_business_name=${payload.sub_business_name}`
                    : `${this.baseUrl}hotel_billing/reports/franchise/outlet/summary?from_date=${payload.from_date}&to_date=${payload.to_date}&by_business_name=${payload.by_business_name}&page=${payload.pageNumber}&limit=${payload.limit}`;
                const response = yield axios_1.default.get(url, {
                    transformResponse: [
                        (data, headers) => {
                            return data;
                        },
                        ...axios_1.default.defaults.transformResponse
                    ],
                    headers: header
                });
                const responseData = response.data.data;
                return responseData;
            }
            catch (error) {
                throw new Error('Failed to fetch reports');
            }
        });
    }
    fetchBillwiseReport(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                // Build base URL
                let baseUrl = `${this.baseUrl}hotel_billing/reports/list_bills/outlet?from_date=${payload.from_date}&to_date=${payload.to_date}&page=${payload.pageNumber}&limit=${payload.limit}`;
                // Add outlet_id only if it exists
                if (payload.outlet_id) {
                    baseUrl += `&outlet_id=${payload.outlet_id}`;
                }
                let url = payload.user_id
                    ? `${baseUrl}&user_id=${payload.user_id}&by_user=true`
                    : baseUrl;
                if (payload.bill_status !== undefined && !(0, utils_1.isEmpty)(payload.bill_status)) {
                    url = `${url}&bill_status=${payload.bill_status}`;
                }
                const response = yield axios_1.default.get(url, {
                    transformResponse: [
                        (data, headers) => {
                            return data;
                        },
                        ...axios_1.default.defaults.transformResponse
                    ],
                    headers: header
                });
                const responseData = response.data.data;
                return responseData;
            }
            catch (error) {
                throw new Error('Failed to fetch reports');
            }
        });
    }
    fetchDaywiseReport(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                // Build base URL
                let url = `${this.baseUrl}hotel_billing/reports/list_datewise_bills/outlet?from_date=${payload.from_date}&to_date=${payload.to_date}&page=${payload.pageNumber}&limit=${payload.limit}`;
                // Add outlet_id only if it exists
                if (payload.outlet_id) {
                    url += `&outlet_id=${payload.outlet_id}`;
                }
                const response = yield axios_1.default.get(url, {
                    transformResponse: [
                        (data, headers) => {
                            return data;
                        },
                        ...axios_1.default.defaults.transformResponse
                    ],
                    headers: header
                });
                const responseData = response.data.data;
                return responseData;
            }
            catch (error) {
                throw new Error('Failed to fetch reports');
            }
        });
    }
    fetchItemWiseReport(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                // Build base URL
                let baseUrl = `${this.baseUrl}hotel_billing/reports/list_bill_items/outlet?from_date=${payload.from_date}&to_date=${payload.to_date}&page=${payload.pageNumber}&limit=${payload.limit}`;
                // Add outlet_id only if it exists
                if (payload.outlet_id) {
                    baseUrl += `&outlet_id=${payload.outlet_id}`;
                }
                let url = payload.kitchen_counter_id
                    ? `${baseUrl}&kitchen_counter_id=${payload.kitchen_counter_id}&by_kitchen_counter=true`
                    : baseUrl;
                const response = yield axios_1.default.get(url, {
                    transformResponse: [
                        (data, headers) => {
                            return data;
                        },
                        ...axios_1.default.defaults.transformResponse
                    ],
                    headers: header
                });
                const responseData = response.data.data;
                return responseData;
            }
            catch (error) {
                throw new Error('Failed to fetch reports');
            }
        });
    }
    fetchInventoryReport(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                // Build base URL
                let url = `${this.baseUrl}hotel_billing/reports/inventory?report_date=${payload.report_date}&page=${payload.pageNumber}&limit=${payload.limit}`;
                // Add outlet_id only if it exists
                if (payload.outlet_id) {
                    url += `&outlet_id=${payload.outlet_id}`;
                }
                const response = yield axios_1.default.get(url, {
                    transformResponse: [
                        (data, headers) => {
                            return data;
                        },
                        ...axios_1.default.defaults.transformResponse
                    ],
                    headers: header
                });
                const responseData = response.data.data;
                return responseData;
            }
            catch (error) {
                throw new Error('Failed to fetch reports');
            }
        });
    }
    fetchUserwiseReport(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                // Build base URL
                let url = `${this.baseUrl}hotel_billing/reports/user/outlet?from_date=${payload.from_date}&to_date=${payload.to_date}&page=${payload.pageNumber}&limit=${payload.limit}`;
                // Add outlet_id only if it exists
                if (payload.outlet_id) {
                    url += `&outlet_id=${payload.outlet_id}`;
                }
                const response = yield axios_1.default.get(url, {
                    transformResponse: [
                        (data, headers) => JSONbig.parse(data),
                        ...axios_1.default.defaults.transformResponse
                    ],
                    headers: header
                });
                const responseData = response.data.data;
                return responseData;
            }
            catch (error) {
                throw new Error('Failed to fetch reports');
            }
        });
    }
    fetchCounterWiseReport(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                // Build base URL
                let url = `${this.baseUrl}hotel_billing/reports/counter/outlet?from_date=${payload.from_date}&to_date=${payload.to_date}&page=${payload.pageNumber}&limit=${payload.limit}`;
                // Add outlet_id only if it exists
                if (payload.outlet_id) {
                    url += `&outlet_id=${payload.outlet_id}`;
                }
                const response = yield axios_1.default.get(url, {
                    transformResponse: [
                        (data, headers) => JSONbig.parse(data),
                        ...axios_1.default.defaults.transformResponse
                    ],
                    headers: header
                });
                const responseData = response.data.data;
                return responseData;
            }
            catch (error) {
                throw new Error('Failed to fetch reports');
            }
        });
    }
    fetchWriteOffReport(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                // Build base URL
                let url = `${this.baseUrl}hotel_billing/reports/writeoff/outlet?from_date=${payload.from_date}&to_date=${payload.to_date}&page=${payload.pageNumber}&limit=${payload.limit}`;
                // Add outlet_id only if it exists
                if (payload.outlet_id) {
                    url += `&outlet_id=${payload.outlet_id}`;
                }
                const response = yield axios_1.default.get(url, {
                    transformResponse: [
                        (data, headers) => {
                            return data;
                        },
                        ...axios_1.default.defaults.transformResponse
                    ],
                    headers: header
                });
                const responseData = response.data.data;
                return responseData;
            }
            catch (error) {
                throw new Error('Failed to fetch reports');
            }
        });
    }
    fetchDuplicateBillReport(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                // Build base URL
                let url = `${this.baseUrl}hotel_billing/reports/duplicate_bill/outlet?from_date=${payload.from_date}&to_date=${payload.to_date}&page=${payload.pageNumber}&limit=${payload.limit}`;
                // Add outlet_id only if it exists
                if (payload.outlet_id) {
                    url += `&outlet_id=${payload.outlet_id}`;
                }
                const response = yield axios_1.default.get(url, {
                    transformResponse: [
                        (data, headers) => {
                            return data;
                        },
                        ...axios_1.default.defaults.transformResponse
                    ],
                    headers: header
                });
                const responseData = response.data.data;
                return responseData;
            }
            catch (error) {
                throw new Error('Failed to fetch reports');
            }
        });
    }
    fetchPaymentwiseReport(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                // Build base URL
                let url = `${this.baseUrl}hotel_billing/reports/payment_mode/outlet?from_date=${payload.from_date}&to_date=${payload.to_date}&page=${payload.pageNumber}&limit=${payload.limit}`;
                // Add outlet_id only if it exists
                if (payload.outlet_id) {
                    url += `&outlet_id=${payload.outlet_id}`;
                }
                const response = yield axios_1.default.get(url, {
                    transformResponse: [
                        (data, headers) => {
                            return data;
                        },
                        ...axios_1.default.defaults.transformResponse
                    ],
                    headers: header
                });
                const responseData = response.data.data;
                return responseData;
            }
            catch (error) {
                throw new Error('Failed to fetch reports');
            }
        });
    }
    downloadReports(payload) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                let baseUrlPart = `${this.baseUrl}hotel_billing/reports/`;
                let url = "";
                switch (payload.type) {
                    case "inventory": {
                        url = `${baseUrlPart}inventory?report_date=${payload.report_date}&page=${payload.pageNumber}&limit=${payload.limit}`;
                        if (payload.outlet_id) {
                            url += `&outlet_id=${payload.outlet_id}`;
                        }
                        break;
                    }
                    case "billwise": {
                        let billwiseBaseUrl = `${baseUrlPart}list_bills/outlet?from_date=${payload.from_date}&to_date=${payload.to_date}&page=${payload.pageNumber}&limit=${payload.limit}`;
                        if (payload.outlet_id) {
                            billwiseBaseUrl += `&outlet_id=${payload.outlet_id}`;
                        }
                        url = payload.user_id ?
                            `${billwiseBaseUrl}&user_id=${payload.user_id}&by_user=true` :
                            billwiseBaseUrl;
                        break;
                    }
                    case "daywise": {
                        url = `${baseUrlPart}list_datewise_bills/outlet?from_date=${payload.from_date}&to_date=${payload.to_date}&page=${payload.pageNumber}&limit=${payload.limit}`;
                        if (payload.outlet_id) {
                            url += `&outlet_id=${payload.outlet_id}`;
                        }
                        break;
                    }
                    case "itemwise": {
                        let itemwiseBaseUrl = `${baseUrlPart}list_bill_items/outlet?from_date=${payload.from_date}&to_date=${payload.to_date}&page=${payload.pageNumber}&limit=${payload.limit}`;
                        if (payload.outlet_id) {
                            itemwiseBaseUrl += `&outlet_id=${payload.outlet_id}`;
                        }
                        url = payload.kitchen_counter_id ?
                            `${itemwiseBaseUrl}&kitchen_counter_id=${payload.kitchen_counter_id}&by_kitchen_counter=true` :
                            itemwiseBaseUrl;
                        break;
                    }
                    case "duplicatebill": {
                        url = `${baseUrlPart}duplicate_bill/outlet?from_date=${payload.from_date}&to_date=${payload.to_date}&page=${payload.pageNumber}&limit=${payload.limit}`;
                        if (payload.outlet_id) {
                            url += `&outlet_id=${payload.outlet_id}`;
                        }
                        break;
                    }
                    case "writeoff": {
                        url = `${baseUrlPart}writeoff/outlet?from_date=${payload.from_date}&to_date=${payload.to_date}&page=${payload.pageNumber}&limit=${payload.limit}`;
                        if (payload.outlet_id) {
                            url += `&outlet_id=${payload.outlet_id}`;
                        }
                        break;
                    }
                    case "userwise": {
                        url = `${baseUrlPart}user/outlet?from_date=${payload.from_date}&to_date=${payload.to_date}&page=${payload.pageNumber}&limit=${payload.limit}`;
                        if (payload.outlet_id) {
                            url += `&outlet_id=${payload.outlet_id}`;
                        }
                        break;
                    }
                    case "paymentwise": {
                        url = `${baseUrlPart}payment_mode/outlet?from_date=${payload.from_date}&to_date=${payload.to_date}&page=${payload.pageNumber}&limit=${payload.limit}`;
                        if (payload.outlet_id) {
                            url += `&outlet_id=${payload.outlet_id}`;
                        }
                        break;
                    }
                    case "counterwise": {
                        url = `${baseUrlPart}counter/outlet?from_date=${payload.from_date}&to_date=${payload.to_date}&page=${payload.pageNumber}&limit=${payload.limit}`;
                        if (payload.outlet_id) {
                            url += `&outlet_id=${payload.outlet_id}`;
                        }
                        break;
                    }
                    case "userwisebill": {
                        url = `${baseUrlPart}${payload.url}/outlet?from_date=${payload.from_date}&to_date=${payload.to_date}&page=${payload.pageNumber}&limit=${payload.limit}&user_id=${payload.user_id}&by_user=true`;
                        if (payload.outlet_id) {
                            url += `&outlet_id=${payload.outlet_id}`;
                        }
                        break;
                    }
                    case "counterwisereportbill": {
                        url = `${baseUrlPart}${payload.url}/outlet?from_date=${payload.from_date}&to_date=${payload.to_date}&page=${payload.pageNumber}&limit=${payload.limit}&kitchen_counter_id=${payload.kitchen_counter_id}&by_kitchen_counter=true`;
                        if (payload.outlet_id) {
                            url += `&outlet_id=${payload.outlet_id}`;
                        }
                        break;
                    }
                    case "summary": {
                        let summaryBaseUrl = `${baseUrlPart}${payload.url}/outlet/summary?from_date=${payload.from_date}&to_date=${payload.to_date}`;
                        if (payload.outlet_id) {
                            summaryBaseUrl += `&outlet_id=${payload.outlet_id}`;
                        }
                        url = summaryBaseUrl;
                        break;
                    }
                    case "outletwise_summary":
                        url = `${baseUrlPart}outlet/summary?from_date=${payload.from_date}&to_date=${payload.to_date}`;
                        break;
                    case "outletwise_summary_franchise": {
                        url = payload.sub_business_name
                            ? `${baseUrlPart}franchise/outlet/summary?from_date=${payload.from_date}&to_date=${payload.to_date}&by_business_name=${payload.by_business_name}&page=${payload.pageNumber}&limit=${payload.limit}&sub_business_name=${payload.sub_business_name}`
                            : `${baseUrlPart}franchise/outlet/summary?from_date=${payload.from_date}&to_date=${payload.to_date}&by_business_name=${payload.by_business_name}&page=${payload.pageNumber}&limit=${payload.limit}`;
                        break;
                    }
                    case "franchisewise_summary": {
                        url = `${baseUrlPart}franchise/outlet/summary?from_date=${payload.from_date}&to_date=${payload.to_date}&by_business_name=${payload.by_business_name}&page=${payload.pageNumber}&limit=${payload.limit}`;
                        break;
                    }
                    case "allreports": {
                        url = `${baseUrlPart}${payload.url}/outlet?from_date=${payload.from_date}&to_date=${payload.to_date}&page=${payload.pageNumber}&limit=${payload.limit}`;
                        if (payload.outlet_id) {
                            url += `&outlet_id=${payload.outlet_id}`;
                        }
                        break;
                    }
                }
                if (payload.bill_status !== undefined && !(0, utils_1.isEmpty)(payload.bill_status)) {
                    url = `${url}&bill_status=${payload.bill_status}`;
                }
                const response = yield axios_1.default.get(url, {
                    transformResponse: [
                        (data, headers) => { return data; },
                        ...axios_1.default.defaults.transformResponse,
                    ],
                    headers: header
                });
                let responseData = response === null || response === void 0 ? void 0 : response.data.data.data;
                // If the total limit is more than 100, fetch the remaining pages of data
                if (payload.total > 100) {
                    const totalPages = Math.ceil(payload.total / 100);
                    for (let i = payload.pageNumber + 1; i <= totalPages; i++) {
                        payload.pageNumber = i;
                        let url = "";
                        switch (payload.type) {
                            case "inventory": {
                                url = `${baseUrlPart}inventory?report_date=${payload.report_date}&page=${payload.pageNumber}&limit=${payload.limit}`;
                                if (payload.outlet_id) {
                                    url += `&outlet_id=${payload.outlet_id}`;
                                }
                                break;
                            }
                            case "billwise": {
                                let billwiseBaseUrl = `${baseUrlPart}list_bills/outlet?from_date=${payload.from_date}&to_date=${payload.to_date}&page=${payload.pageNumber}&limit=${payload.limit}`;
                                if (payload.outlet_id) {
                                    billwiseBaseUrl += `&outlet_id=${payload.outlet_id}`;
                                }
                                url = payload.user_id ?
                                    `${billwiseBaseUrl}&user_id=${payload.user_id}&by_user=true` :
                                    billwiseBaseUrl;
                                break;
                            }
                            case "daywise": {
                                url = `${baseUrlPart}list_datewise_bills/outlet?from_date=${payload.from_date}&to_date=${payload.to_date}&page=${payload.pageNumber}&limit=${payload.limit}`;
                                if (payload.outlet_id) {
                                    url += `&outlet_id=${payload.outlet_id}`;
                                }
                                break;
                            }
                            case "itemwise": {
                                let itemwiseBaseUrl = `${baseUrlPart}list_bill_items/outlet?from_date=${payload.from_date}&to_date=${payload.to_date}&page=${payload.pageNumber}&limit=${payload.limit}`;
                                if (payload.outlet_id) {
                                    itemwiseBaseUrl += `&outlet_id=${payload.outlet_id}`;
                                }
                                url = payload.kitchen_counter_id ?
                                    `${itemwiseBaseUrl}&kitchen_counter_id=${payload.kitchen_counter_id}&by_kitchen_counter=true` :
                                    itemwiseBaseUrl;
                                break;
                            }
                            case "duplicatebill": {
                                url = `${baseUrlPart}duplicate_bill/outlet?from_date=${payload.from_date}&to_date=${payload.to_date}&page=${payload.pageNumber}&limit=${payload.limit}`;
                                if (payload.outlet_id) {
                                    url += `&outlet_id=${payload.outlet_id}`;
                                }
                                break;
                            }
                            case "writeoff": {
                                url = `${baseUrlPart}writeoff/outlet?from_date=${payload.from_date}&to_date=${payload.to_date}&page=${payload.pageNumber}&limit=${payload.limit}`;
                                if (payload.outlet_id) {
                                    url += `&outlet_id=${payload.outlet_id}`;
                                }
                                break;
                            }
                            case "userwisebill": {
                                url = `${baseUrlPart}${payload.url}/outlet?from_date=${payload.from_date}&to_date=${payload.to_date}&page=${payload.pageNumber}&limit=${payload.limit}&user_id=${payload.user_id}&by_user=true`;
                                if (payload.outlet_id) {
                                    url += `&outlet_id=${payload.outlet_id}`;
                                }
                                break;
                            }
                            case "counterwisereportbill": {
                                url = `${baseUrlPart}${payload.url}/outlet?from_date=${payload.from_date}&to_date=${payload.to_date}&page=${payload.pageNumber}&limit=${payload.limit}&kitchen_counter_id=${payload.kitchen_counter_id}&by_kitchen_counter=true`;
                                if (payload.outlet_id) {
                                    url += `&outlet_id=${payload.outlet_id}`;
                                }
                                break;
                            }
                            case "summary": {
                                url = `${baseUrlPart}${payload.url}/outlet/summary?from_date=${payload.from_date}&to_date=${payload.to_date}`;
                                if (payload.outlet_id) {
                                    url += `&outlet_id=${payload.outlet_id}`;
                                }
                                break;
                            }
                            case "allreports": {
                                url = `${baseUrlPart}${payload.url}/outlet?from_date=${payload.from_date}&to_date=${payload.to_date}&page=${payload.pageNumber}&limit=${payload.limit}`;
                                if (payload.outlet_id) {
                                    url += `&outlet_id=${payload.outlet_id}`;
                                }
                                break;
                            }
                            default:
                                console.error("Unsupported report type:", payload.type);
                                return;
                        }
                        if (payload.bill_status !== undefined && !(0, utils_1.isEmpty)(payload.bill_status)) {
                            url = `${url}&bill_status=${payload.bill_status}`;
                        }
                        const response = yield axios_1.default.get(url, {
                            transformResponse: [
                                (data, headers) => { return data; },
                                ...axios_1.default.defaults.transformResponse,
                            ],
                            headers: header
                        });
                        responseData = [...responseData, ...(_a = response.data) === null || _a === void 0 ? void 0 : _a.data.data];
                    }
                }
                return responseData;
            }
            catch (error) {
                throw new Error("Failed to fetch reports");
            }
        });
    }
    fetchBillDetails(billId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const header = (0, utils_1.getHeader)();
                const url = `${this.baseUrl}hotel_billing/bill/billitem?id=${billId}`;
                const response = yield axios_1.default.get(url, {
                    transformResponse: [
                        (data, headers) => { return data; },
                        ...axios_1.default.defaults.transformResponse,
                    ],
                    headers: header
                });
                return response.data;
            }
            catch (error) {
                throw new Error("Failed to fetch bill details");
            }
        });
    }
    fetchWaiterItemWiseReport(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                let url = `${this.baseUrl}hotel_billing/reports/waiter/itemwise/outlet?from_date=${payload.from_date}&to_date=${payload.to_date}&waiter_id=${payload.waiter_id}&outlet_id=${payload.outlet_id}&page=${payload.pageNumber}&limit=${payload.limit}`;
                if (payload.commission_mode !== undefined && payload.commission_mode !== null) {
                    url += `&commission_mode=${payload.commission_mode}`;
                }
                const response = yield axios_1.default.get(url, {
                    transformResponse: [
                        (data, headers) => { return data; },
                        ...axios_1.default.defaults.transformResponse,
                    ],
                    headers: header
                });
                return response.data.data;
            }
            catch (error) {
                throw new Error('Failed to fetch reports');
            }
        });
    }
    fetchWaiterCommissionReport(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                let url = `${this.baseUrl}hotel_billing/reports/waiter/commission/outlet?from_date=${payload.from_date}&to_date=${payload.to_date}&page=${payload.pageNumber}&limit=${payload.limit}`;
                if (payload.outlet_id) {
                    url += `&outlet_id=${payload.outlet_id}`;
                }
                if (payload.commission_mode !== undefined && payload.commission_mode !== null) {
                    url += `&commission_mode=${payload.commission_mode}`;
                }
                const response = yield axios_1.default.get(url, {
                    transformResponse: [
                        (data, headers) => { return data; },
                        ...axios_1.default.defaults.transformResponse,
                    ],
                    headers: header
                });
                return response.data.data;
            }
            catch (error) {
                throw new Error('Failed to fetch reports');
            }
        });
    }
    fetchWaiterMonthWiseReport(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                let url = `${this.baseUrl}hotel_billing/reports/waiter/monthwise/outlet?from_date=${payload.from_date}&to_date=${payload.to_date}&waiter_id=${payload.waiter_id}&outlet_id=${payload.outlet_id}&page=${payload.pageNumber}&limit=${payload.limit}`;
                if (payload.commission_mode !== undefined && payload.commission_mode !== null) {
                    url += `&commission_mode=${payload.commission_mode}`;
                }
                const response = yield axios_1.default.get(url, {
                    transformResponse: [
                        (data, headers) => { return data; },
                        ...axios_1.default.defaults.transformResponse,
                    ],
                    headers: header
                });
                return response.data.data;
            }
            catch (error) {
                throw new Error('Failed to fetch reports');
            }
        });
    }
    fetchWaiterSalesReport(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                let url = `${this.baseUrl}hotel_billing/reports/waiter/sales/outlet?from_date=${payload.from_date}&to_date=${payload.to_date}&waiter_id=${payload.waiter_id}&outlet_id=${payload.outlet_id}&page=${payload.pageNumber}&limit=${payload.limit}`;
                if (payload.commission_mode !== undefined && payload.commission_mode !== null) {
                    url += `&commission_mode=${payload.commission_mode}`;
                }
                const response = yield axios_1.default.get(url, {
                    transformResponse: [
                        (data, headers) => { return data; },
                        ...axios_1.default.defaults.transformResponse,
                    ],
                    headers: header
                });
                return response.data.data;
            }
            catch (error) {
                throw new Error('Failed to fetch reports');
            }
        });
    }
}
exports.ReportService = ReportService;
